import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./phases.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./phases.component.scss?ngResource";
import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { DashboardConstants } from "../dashboard.constants";
import { Router } from "@angular/router";
import { SharedConstants } from "../../../shared/constants/shared.constants";
import { AppControllerService } from "../../../app-controller.service";
import { DashboardService } from "../shared/dashboard.service";
import { AppRoutingConstants } from "../../../app-routing.constants";
import { ApplicationsRoutingConstants } from "../../../tabs/applications/applications-routing.constants";
let PhasesComponent = class PhasesComponent {
    router;
    appService;
    dashbordSerice;
    phases;
    module;
    noItem = SharedConstants.NO_ITEMS_AVAILABLE_MESSAGE;
    phasesHeading = DashboardConstants.PHASES_HEADING;
    constructor(router, appService, dashbordSerice) {
        this.router = router;
        this.appService = appService;
        this.dashbordSerice = dashbordSerice;
    }
    ngOnInit() { }
    trackPhase(index, item) {
        return index;
    }
    filterApplication(applicationStatus) {
        this.dashbordSerice.filterApplicationBehaviour.next(applicationStatus);
        this.appService.setSelectedModule(this.module.id);
        this.router.navigate([AppRoutingConstants.ROUTE_SEPERATOR +
                this.appService.selectedModuleID + AppRoutingConstants.ROUTE_SEPERATOR +
                ApplicationsRoutingConstants.APPLICATIONS_ROUTE]);
    }
    static ctorParameters = () => [
        { type: Router },
        { type: AppControllerService },
        { type: DashboardService }
    ];
    static propDecorators = {
        phases: [{ type: Input }],
        module: [{ type: Input }]
    };
};
PhasesComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-phases",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], PhasesComponent);
export { PhasesComponent };
